<template>
    <div class="scheme-channel-card">
        <!-- Блок стрелок приоритета слева -->
        <div class="priority-controls-left">
            <button
                :class="{ disabled: isFirst }"
                class="priority-panel-button top"
                v-ripple
                @click="handleMoveUp"
                :disabled="isFirst"
            >
                <v-icon>mdi-menu-up</v-icon>
            </button>
            <button
                :class="{ disabled: isLast }"
                class="priority-panel-button bottom"
                v-ripple
                @click="handleMoveDown"
                :disabled="isLast"
            >
                <v-icon>mdi-menu-down</v-icon>
            </button>
        </div>

        <!-- Основной контент плашки -->
        <div class="channel-main-content">
            <!-- Заголовок с приоритетом и управлением -->
            <div class="channel-header">
                <div class="priority-panel">
                    <span class="priority-text">Приоритет {{ priority }}</span>
                    <div class="header-center">
                        <img
                            src="@/assets/icons/drag-indicator.svg"
                            class="drag-handle"
                            style="cursor: grab;"
                        />
                    </div>
                    <v-icon
                        small
                        color="grey"
                        class="delete-icon"
                        @click="$emit('delete')"
                    >
                        mdi-delete-outline
                    </v-icon>
                </div>
            </div>

            <!-- Основной контент канала -->
            <div class="channel-content">
                <div class="channel-icon-wrapper">
                    <img
                        v-if="getChannelLogo(channel.type)"
                        :src="getChannelLogo(channel.type)"
                        :alt="channel.type"
                        class="channel-icon-img"
                    />
                    <div
                        v-else
                        class="channel-icon"
                        :class="getChannelIconClass(channel.type)"
                    >
                        <span v-if="channel.type === 'YCLIENTS'">YC</span>
                        <span v-else-if="channel.type === 'MAX'">M</span>
                        <span v-else>{{ channel.type.charAt(0) }}</span>
                    </div>
                </div>
                <div class="channel-info">
                    <div class="channel-name">{{ channel.name || channel.type }}</div>
                    <div v-if="channel.phone" class="channel-phone">{{ channel.phone }}</div>
                </div>
                <div class="channel-status">
                    <span v-if="isConnected" class="status-connected">подключен</span>
                    <v-btn
                        v-else
                        small
                        outlined
                        color="success"
                        @click="$emit('connect')"
                    >
                        подключить
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SchemeChannelCard',
    props: {
        channel: {
            type: Object,
            required: true,
        },
        priority: {
            type: Number,
            required: true,
        },
        isFirst: {
            type: Boolean,
            default: false,
        },
        isLast: {
            type: Boolean,
            default: false,
        },
        connectedChannels: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        isConnected() {
            if (this.channel.connected !== undefined) {
                return this.channel.connected
            }
            const connected = this.connectedChannels.find(ch => ch.id === this.channel.id)
            return connected?.connected || false
        },
    },
    methods: {
        getChannelLogo(type) {
            const logoMap = {
                MAX: require('@/assets/img/messenger-logo/max-logo.png'),
                Telegram: require('@/assets/img/messenger-logo/telegram-logo.png'),
                WhatsApp: require('@/assets/img/messenger-logo/wa-logo.png'),
                YCLIENTS: null,
            }
            return logoMap[type] !== undefined ? logoMap[type] : null
        },
        getChannelIconClass(type) {
            const classMap = {
                YCLIENTS: 'channel-icon-yclients',
                MAX: 'channel-icon-max',
                Telegram: 'channel-icon-telegram',
                WhatsApp: 'channel-icon-whatsapp',
            }
            return classMap[type] || 'channel-icon-default'
        },
        handleMoveUp() {
            if (!this.isFirst) {
                this.$emit('move-up')
            }
        },
        handleMoveDown() {
            if (!this.isLast) {
                this.$emit('move-down')
            }
        },
        preventTextSelection(event) {
            event.preventDefault()
            return false
        },
    },
    mounted() {
        // Предотвращаем выделение текста при перетаскивании
        const card = this.$el
        if (card) {
            card.addEventListener('selectstart', this.preventTextSelection)
            card.addEventListener('dragstart', this.preventTextSelection)
        }
    },
    beforeDestroy() {
        const card = this.$el
        if (card) {
            card.removeEventListener('selectstart', this.preventTextSelection)
            card.removeEventListener('dragstart', this.preventTextSelection)
        }
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.scheme-channel-card
    background: white
    border: 1px solid #E0E0E0
    border-radius: 8px
    margin-bottom: 12px
    display: flex
    gap: 12px
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    -webkit-touch-callout: none
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none

.priority-controls-left
    display: flex
    flex-direction: column
    justify-content: space-between
    align-items: stretch
    flex-shrink: 0
    width: 32px
    border-right: 1px solid #E0E0E0

.priority-panel-button
    display: flex
    align-items: center
    justify-content: center
    background: transparent
    border: none
    padding: 0
    cursor: pointer
    flex: 1
    min-height: 0
    transition: background-color 0.2s ease
    &.top
        border-bottom: 1px solid #E0E0E0
    &.bottom
        border-top: none
    &:hover:not(.disabled)
        background-color: rgba(0, 0, 0, 0.05)
    &.disabled
        opacity: 0.3
        cursor: not-allowed
        pointer-events: none

.channel-main-content
    flex: 1
    display: flex
    flex-direction: column

.channel-header
    margin-bottom: 12px
    width: 100%

.priority-panel
    display: flex
    align-items: center
    justify-content: space-between
    background-color: #2A3B510B
    padding: 6px 12px
    border-radius: 4px
    width: 100%
    height: 24px
    position: relative
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    -webkit-touch-callout: none
    cursor: grab
    &:active
        cursor: grabbing

.priority-text
    font-size: 12px
    color: #7F8997
    font-weight: 500
    line-height: 16px
    flex-shrink: 0
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none

.header-center
    position: absolute
    left: 50%
    transform: translateX(-50%)
    display: flex
    align-items: center
    justify-content: center
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none

.drag-handle
    cursor: grab
    transition: cursor 0.2s ease
    width: 12px
    height: 12px
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    pointer-events: none
    &:active
        cursor: grabbing
    &:hover
        opacity: 0.8

.delete-icon
    cursor: pointer
    opacity: 0.6
    flex-shrink: 0
    pointer-events: auto
    position: relative
    z-index: 10
    &:hover
        opacity: 1
        color: #F44336

.delete-icon
    cursor: pointer
    opacity: 0.6
    &:hover
        opacity: 1
        color: #F44336

.channel-content
    display: flex
    align-items: center
    gap: 16px
    padding: 8px 0

.channel-icon-wrapper
    width: 48px
    height: 48px
    flex-shrink: 0
    display: flex
    align-items: center
    justify-content: center

.channel-icon-img
    width: 48px
    height: 48px
    object-fit: contain

.channel-icon
    width: 48px
    height: 48px
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    color: white
    font-weight: bold
    font-size: 16px

.channel-icon-yclients
    background: #FFC107

.channel-icon-max
    background: linear-gradient(135deg, #9C27B0 0%, #2196F3 100%)

.channel-icon-telegram
    background: #2196F3

.channel-icon-whatsapp
    background: #25D366

.channel-icon-default
    background: #7F8997

.channel-info
    flex: 1
    min-width: 0

.channel-name
    font-size: 16px
    font-weight: 600
    color: #2A3B51
    text-transform: uppercase
    margin-bottom: 4px

.channel-phone
    font-size: 14px
    color: #7F8997

.channel-status
    flex-shrink: 0

.status-connected
    display: inline-block
    padding: 6px 12px
    border: 1px solid #4CAF50
    border-radius: 4px
    color: #4CAF50
    font-size: 12px
    font-weight: 500
</style>

